import { ChangeDetectionStrategy, Component, computed, inject, input, output, viewChild } from '@angular/core';
import { DeleteFileParams } from "../../../../../types/product-card-files.types";
import { ListingFilesModalService } from "../../services/listing-files-modal.service";
import { ListingFilesStateService } from "../../services/listing-files-state.service";
import { ListingFileData } from "../../types/listing-file-data.types";
import { defaultListingFileData } from "../../configs/default-listing-file-data";
import { RecordUpdateRequestParams } from "../../../../../../../../core/types/records-table.types";
import { uspPrioritySelectData } from "../../configs/usp-priority-select-data";
import { ErrorService } from "../../../../../../../../core/services/error.service";
import {
  CustomMatSelectComponent
} from "../../../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { FileCardComponent } from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import { ListingPathStateService } from "../../services/listing-path-state.service";
import { EntityFileType } from "../../../../../../../../core/types/file.types";

@Component({
  selector: 'div[app-lf-file-card]',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    FileCardComponent,
    CustomMatSelectComponent
  ],
  templateUrl: './lf-file-card.component.html',
  styleUrl: './lf-file-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LfFileCardComponent {
  file = input<ListingFileData>(defaultListingFileData);
  listingEntityFileType = input<EntityFileType>('LISTING');
  isEditModeActive = input<boolean>(false);
  updateField = output<ListingFileData>();
  customSelect = viewChild<CustomMatSelectComponent>('customSelect');

  public listingFilesStateService: ListingFilesStateService = inject(ListingFilesStateService);
  private listingFilesModalService: ListingFilesModalService = inject(ListingFilesModalService);
  private errorService: ErrorService = inject(ErrorService);
  private listingPathStateService: ListingPathStateService = inject(ListingPathStateService);

  public readonly uspPrioritySelectData = uspPrioritySelectData;
  public selectedUspPriority = computed(() => String(this.file().uspPriority));

  public handleDelete(isImage: boolean): void {
    const params: DeleteFileParams = {
      path: this.listingPathStateService.pathState(),
      id: this.file().id
    };

    this.listingFilesModalService.deleteFile(params)
      .then(() => this.listingFilesStateService.deleteFileById(this.file().id));
  }

  public async handleUpdateField(key: string): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.listingPathStateService.pathState(),
      recordId: this.file().id,
      fieldName: key,
      value: this.file()[key]
    };

    await this.updateFieldListingData(params)
  }

  public async handleUpdateUspPriority(value: string): Promise<void> {
    const newUspPriority = Number(value);

    if (this.listingFilesStateService.hasFileWithUspPriority(newUspPriority)) {
      this.errorService.showErrorMessage('Такой приоритет уже установлен!');
      this.customSelect()?.resetToValue(this.selectedUspPriority());
      return;
    }

    const params: RecordUpdateRequestParams = {
      path: this.listingPathStateService.pathState(),
      recordId: this.file().id,
      fieldName: 'uspPriority',
      value: newUspPriority
    };

    await this.updateFieldListingData(params);
  }

  private async updateFieldListingData(params: RecordUpdateRequestParams): Promise<void> {
    const updateData = await this.listingFilesModalService.updatedRecordField<ListingFileData>(params).catch(() => this.file());
    this.updateField.emit(updateData);
  }
}
